<first>
  <style>
  .bold {
    font-weight: bold;
  }
  ul.attention li {
    margin-left: 1em;
  }
  .bottom_warning{
    width: 60%;
    margin: 2em auto 0 auto;
  }
  </style>
  
  <section class="sec-top-function com-bg-gray">
    <div class="sec-top-inner sec-inner">
      <header class="sec-top-header">
        <h2 class="sec-top__ttl"><span>メールアドレス認証</span></h2>
        <!--
        <p>ログインIDや当サイトからのご連絡先として使用するメールアドレスを入力してください。</p>
        -->
      </header>
      <ul class="sec-top-function-list">
        <li class="sec-top-function__item">
          <div class="sec-top-function__item__textbox">
            <p class="sec-top-function__item__text">1. ログインIDや当サイトからのご連絡先として使用するメールアドレスを入力してください。</p>
          </div>
        </li>
        <li class="sec-top-function__item">
          <div class="sec-top-function__item__textbox">
            <p class="sec-top-function__item__text">2. 画面が切り替わるので、指定のアドレスに届いた認証コードを入力</p>
          </div>
        </li>
        <li class="sec-top-function__item">
          <div class="sec-top-function__item__textbox">
            <p class="sec-top-function__item__text">3. 認証コードの入力が済んだら、会員登録に必要な諸情報の入力に進みます</p>
          </div>
        </li>

      </ul>
    </div>
  </section>

  <div class="com-article-inner">
    <div class="sec-inner">
      <div class="sec-basic-input__wrap com-bg-white">
        <section class="sec-basic-input">
          <div class="com-form">
            <form>
              <div class="com-form__item__content">
                <div class="com-form__item__input input-text">
                  <input type="text" autocomplete="username" name="mail" data="{data}" is="edireco-binding" validate="email" placeholder="メールアドレスを入力して下さい" errMsg="メールアドレスを入力して下さい" required>
                </div>
              </div>


              <div class="com-form__submit">
                <button type="button" class="com-btn-01" onclick="{dump}" if={!isLoading}><span>認証コードを送信</span></button>
              </div>

            </form>
          </div>
        </section>

        <section class="sec-basic-input bottom_warning">
          <ul class="attention">
            <li>
              メールが届かない場合は、迷惑メールのフォルダをご確認ください<br>
              1時間経過しても届かない場合は、メールアドレスの入力を再度お試しください
            </li>
            <li>認証コードは1時間有効です。時間を超過した場合はやり直してください</li>
            <li>やり直した場合は有効時間内であっても古い認証コードは無効となります</li>
            <li>すでにコードを受け取っている場合は<a href="/register/confirm-code" class="bold">こちらから</a>ご入力ください</li>
          </ul>
        </section>
      </div>
    </div>

<!--
  <div class="com-article-inner">
    <div class="sec-inner">
      <div class="sec-basic-input__wrap com-bg-white">
        <section class="sec-basic-input">
          <ul class="attention">
            <li>
              メールが届かない場合は、迷惑メールのフォルダをご確認ください<br>
              1時間経過しても届かない場合は、メールアドレスの入力を再度お試しください
            </li>
            <li>認証コードは1時間有効です。時間を超過した場合はやり直してください</li>
            <li>やり直した場合は有効時間内であっても古い認証コードは無効となります</li>
            <li>すでにコードを受け取っている場合は<a href="/register/confirm-code" class="bold">こちらから</a>ご入力ください</li>
          </ul>
        </section>
      </div>
    </div>
  </div>
    -->


  <script>
    import di from 'dependeny-injection'

    export default {
      data: di.register.mailData,
      isLoading: false,
      onMounted(props, states){
        scrollTo(0, 0);
      },
      dump(e) {
        e.preventDefault();

        if (this.data.validate()) {
          di.register.changeLoaderState(true, this, 'isLoading');
          di.register.api('/first', this.data.toData())
            .then((data) => {
              di.register.changeLoaderState(false, this, 'isLoading');
              if (data.status) {
                di.register.masked_mail = data.masked_mail;
                di.route.router.push("/confirm-code");
              } else {
                alert(data.message);
              }

            })
        }
      }
    }
  </script>
</first>